import React from "react";
import ShareHoldersSection from "../../components/Investor/ShareHolders.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";
const ShareHolder = () => {
  return (
    <>
      <MetaComponent
        title="Aptech Limited Investor Queries | Contact Details & Support."
        desc="Learn how to update your KYC details for Aptech shares and claim IEPF refunds. Find key investor contacts, KYC guidelines, and IEPF refund details for seamless assistance."
        keywords="Aptech investor relations, Aptech contact information, Investor support services "
      />
      <ShareHoldersSection />
    </>
  );
};

export default ShareHolder;
